export const user = (state) => state.user.user.uid;